export class FilterEvent {
  constructor(public dateFilters: DateFilters,
              public typeFilters: TypeFilters,
              public customFilters: Filters[],
              public typeAheadResults?: Filters) {}
}

export interface Filters {
  id?: number;
  name: string;
  type: 'dropdown-multiple' | 'dropdown-single' | 'range' | 'any' | 'type-ahead';
  noFiltersShowsAll: boolean;
  startDate?: Date;
  endDate?: Date;
  filter_values?: FilterProperties[];
}

export interface DateFilters {
  startDate: Date;
  endDate: Date;
  selected_type: DateFilter;
}


export interface TypeFilters {
  name: string;
  filter_types: string[];
  selected_type: string;
}

export interface FilterProperties {
  name?: string;
  value?: string | number;
  boolean?: boolean;
}

export interface ElementFilters {
  date: DateFilter;
  text: string;
}

export interface TypeAheadResults {
  name: string;
  selected_values: FilterProperties[];
}

export type DateFilter = 'All' | 'Day' | 'Week' | 'Month' | 'Year';
export const dateFilterValues: DateFilter[] = ['All', 'Day', 'Week', 'Month', 'Year'];
